import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M14 7h2v2h-2zM14 11h2v2h-2zM14 15h2v2h-2z',
    'M6 19.5a.5.5 0 0 0 .5.5h12.0149A.485.485 0 0 0 19 19.5149V4.485A.485.485 0 0 0 18.5149 4H6.5a.5.5 0 0 0 0 1H11v14H6.5a.5.5 0 0 0-.5.5zM12 5h6v14h-6V5z',
    'M3.1201 11.6748l3-3.5c.1807-.21.497-.2334.7051-.0542a.4993.4993 0 0 1 .0547.7046L4.1582 12l2.7217 3.1748a.5.5 0 0 1-.0547.705A.4954.4954 0 0 1 6.5 16a.5011.5011 0 0 1-.3799-.1748l-3-3.5a.5003.5003 0 0 1 0-.6504z',
  ],
  height: 24,
  width: 24,
});
